
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired7c6"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired7c6"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ifJdc", function(module, exports) {

$parcel$export(module.exports, "register", () => $d49cb2d7b03f6a77$export$6503ec6e8aabbaf, (v) => $d49cb2d7b03f6a77$export$6503ec6e8aabbaf = v);
var $d49cb2d7b03f6a77$export$6503ec6e8aabbaf;
var $d49cb2d7b03f6a77$export$f7ad0328861e2f03;
"use strict";
var $d49cb2d7b03f6a77$var$mapping = new Map();
function $d49cb2d7b03f6a77$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$d49cb2d7b03f6a77$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $d49cb2d7b03f6a77$var$resolve(id) {
    var resolved = $d49cb2d7b03f6a77$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$d49cb2d7b03f6a77$export$6503ec6e8aabbaf = $d49cb2d7b03f6a77$var$register;
$d49cb2d7b03f6a77$export$f7ad0328861e2f03 = $d49cb2d7b03f6a77$var$resolve;

});

var $3d5a74714f3735b8$exports = {};

(parcelRequire("ifJdc")).register(new URL("", import.meta.url).toString(), JSON.parse('["6unee","shopping-list.4689cb51.js","2usor","save-the-children.e7cb9515.png","2AGy0","project-hope.65587b00.png","7adUJ","international-medical-corps.bb14a1fb.png","2KExU","razom.3639a3ee.png","30dzm","action-against-hunger.6319825b.png","e1omX","sergiy-prytula.d33ef8f5.png","8anbz","medecins-sans-frontieres.0a6ef6af.png","6tfSA","world-vision.8a329a07.png","g1g53","united24.9625498b.png","bSbOs","shopping-list.1b08e2a3.css"]'));


//# sourceMappingURL=shopping-list.runtime.cae1cae1.js.map
